export const webClientId = '120251456997-ch1vtdov2r1rlqupn1hcjcupag0qkc32.apps.googleusercontent.com'